import type { CSSProperties } from 'react';

/**
 * Box for an image block.
 *
 * Deliberately not `chartBoxStyle`: an unsized chart falls back to a legacy
 * fixed-height box so old reports keep rendering pixel-identically, and an
 * image has no such legacy. An unsized image instead shows at its natural size,
 * shrunk only if it is wider than the column — which is exactly what the .docx
 * does with no `widthPct` (`scaleToContentWidth`), so preview and export agree.
 *
 * Either way the height comes from the aspect ratio, never from the loaded
 * image, so the measured height is right before the first byte arrives and
 * pagination does not reflow on load.
 */
export const imageBoxStyle = (
    widthPct: number | undefined,
    intrinsic: { width: number; height: number },
): { style: CSSProperties } => ({
    style: {
        width: widthPct === undefined ? `min(100%, ${intrinsic.width}px)` : `${widthPct}%`,
        aspectRatio: `${intrinsic.width} / ${intrinsic.height}`,
        marginInline: 'auto',
    },
});
